import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-charcoal text-paper/80">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-12 sm:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Brand */}
          <div>
            <h3 className="font-serif text-2xl font-semibold text-paper mb-3">
              McCartney Reunion 2027
            </h3>
            <p className="text-base leading-relaxed text-paper/60">
              Honouring 150 years since Thomas McCartney arrived in
              New Zealand from Ireland in 1877.
            </p>
          </div>

          {/* Event Details */}
          <div>
            <h4 className="font-sans text-sm font-semibold uppercase tracking-wider text-bronze mb-4">
              Event Details
            </h4>
            <div className="space-y-2 text-base text-paper/70">
              <p>Friday 22 January 2027 — Welcome</p>
              <p>Saturday 23 January 2027 — Function & Dinner</p>
              <p className="mt-3 text-paper/50">Croydon Lodge, Gore, Southland</p>
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-sans text-sm font-semibold uppercase tracking-wider text-bronze mb-4">
              Quick Links
            </h4>
            <div className="flex flex-col gap-2">
              <Link
                to="/"
                data-testid="footer-home-link"
                className="text-base text-paper/70 hover:text-paper transition-colors"
              >
                Home
              </Link>
              <Link
                to="/activities"
                data-testid="footer-activities-link"
                className="text-base text-paper/70 hover:text-paper transition-colors"
              >
                Programme
              </Link>
              <Link
                to="/plan-your-visit"
                data-testid="footer-plan-visit-link"
                className="text-base text-paper/70 hover:text-paper transition-colors"
              >
                Plan Your Visit
              </Link>
              <Link
                to="/register"
                data-testid="footer-register-link"
                className="text-base text-paper/70 hover:text-paper transition-colors"
              >
                Register Interest
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-paper/10 text-center space-y-3">
          <p className="text-sm text-paper/50">
            For questions, updates or reunion enquiries, please contact:{" "}
            <a
              href="mailto:mccartneyreunion@gmail.com"
              className="text-paper/70 hover:text-paper underline underline-offset-2"
            >
              mccartneyreunion@gmail.com
            </a>
          </p>
          <p className="text-sm text-paper/40">
            A family commemoration for the McCartney whanau, past and present.
          </p>
        </div>
      </div>
    </footer>
  );
}
